/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    ReportForDeploymentProgressResponse,
    ReportForDeploymentProgressResponseFromJSON,
    ReportForDeploymentProgressResponseToJSON,
    ReportForDeviceConnectionCountersResponse,
    ReportForDeviceConnectionCountersResponseFromJSON,
    ReportForDeviceConnectionCountersResponseToJSON,
    ReportForDeviceCounterResponse,
    ReportForDeviceCounterResponseFromJSON,
    ReportForDeviceCounterResponseToJSON,
    ReportForDeviceCountersResponse,
    ReportForDeviceCountersResponseFromJSON,
    ReportForDeviceCountersResponseToJSON,
    ReportForDeviceResponse,
    ReportForDeviceResponseFromJSON,
    ReportForDeviceResponseToJSON,
    ReportForDevicesByWeekResponse,
    ReportForDevicesByWeekResponseFromJSON,
    ReportForDevicesByWeekResponseToJSON,
    ReportForFirmwareGroupsByStbGroupResponse,
    ReportForFirmwareGroupsByStbGroupResponseFromJSON,
    ReportForFirmwareGroupsByStbGroupResponseToJSON,
    ReportForFirmwareGroupsEntryByStbGroupResponse,
    ReportForFirmwareGroupsEntryByStbGroupResponseFromJSON,
    ReportForFirmwareGroupsEntryByStbGroupResponseToJSON,
    ReportForFirmwareGroupsResponse,
    ReportForFirmwareGroupsResponseFromJSON,
    ReportForFirmwareGroupsResponseToJSON,
    ReportForIncorrectRequestsResponse,
    ReportForIncorrectRequestsResponseFromJSON,
    ReportForIncorrectRequestsResponseToJSON,
    ReportForIncorrectRequestsSummaryResponse,
    ReportForIncorrectRequestsSummaryResponseFromJSON,
    ReportForIncorrectRequestsSummaryResponseToJSON,
    ReportForStbGroupsResponse,
    ReportForStbGroupsResponseFromJSON,
    ReportForStbGroupsResponseToJSON,
} from '../models';

export interface FirmwareGroupsByStbGroupExportCsvRequest {
    stbGroupId: string;
    deviceTypeId: string;
}

export interface FirmwareGroupsByStbGroupExportCsvGzRequest {
    stbGroupId: string;
    deviceTypeId: string;
}

export interface ReadDeploymentProgressReportRequest {
    stbGroupId: string;
}

export interface ReadDeviceCounterOverTimeReportRequest {
    deviceTypeId: string;
    nbTotal: number;
}

export interface ReadDeviceReportRequest {
    macAddress?: string | null;
    serialNumber?: string | null;
    stbGroupsHistoryOffset?: number | null;
    stbGroupsHistoryLimit?: number | null;
    upgradeRulesHistoryOffset?: number | null;
    upgradeRulesHistoryLimit?: number | null;
}

export interface ReadDevicesByWeekReportRequest {
    deviceTypeId: string;
}

export interface ReadFirmwareGroupByStbGroupIdReportRequest {
    stbGroupId: string;
}

export interface ReadFirmwareGroupEntryByStbGroupIdReportRequest {
    stbGroupId: string;
    loaderVersion?: string;
    firmwareVersion?: string;
    uiVersion?: string;
}

export interface ReadFirmwareGroupsReportRequest {
    stbGroupId?: string | null;
    firmwareId?: string | null;
}

export interface ReadIncorrectRequestsReportRequest {
    period: string | null;
    offset?: number | null;
    limit?: number | null;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Read firmware groups by stbGroup export.
     */
    async firmwareGroupsByStbGroupExportCsvRaw(requestParameters: FirmwareGroupsByStbGroupExportCsvRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.stbGroupId === null || requestParameters.stbGroupId === undefined) {
            throw new runtime.RequiredError('stbGroupId','Required parameter requestParameters.stbGroupId was null or undefined when calling firmwareGroupsByStbGroupExportCsv.');
        }

        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling firmwareGroupsByStbGroupExportCsv.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/{stbGroupId}/{deviceTypeId}/firmwareGroupsByStbGroup.csv`.replace(`{${"stbGroupId"}}`, encodeURIComponent(String(requestParameters.stbGroupId))).replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read firmware groups by stbGroup export.
     */
    async firmwareGroupsByStbGroupExportCsv(requestParameters: FirmwareGroupsByStbGroupExportCsvRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.firmwareGroupsByStbGroupExportCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmware groups by stbGroup export.
     */
    async firmwareGroupsByStbGroupExportCsvGzRaw(requestParameters: FirmwareGroupsByStbGroupExportCsvGzRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.stbGroupId === null || requestParameters.stbGroupId === undefined) {
            throw new runtime.RequiredError('stbGroupId','Required parameter requestParameters.stbGroupId was null or undefined when calling firmwareGroupsByStbGroupExportCsvGz.');
        }

        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling firmwareGroupsByStbGroupExportCsvGz.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/{stbGroupId}/{deviceTypeId}/firmwareGroupsByStbGroup.csv.gz`.replace(`{${"stbGroupId"}}`, encodeURIComponent(String(requestParameters.stbGroupId))).replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Read firmware groups by stbGroup export.
     */
    async firmwareGroupsByStbGroupExportCsvGz(requestParameters: FirmwareGroupsByStbGroupExportCsvGzRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.firmwareGroupsByStbGroupExportCsvGzRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read all devices counter over time report
     */
    async readAllDevicesCounterOverTimeReportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDeviceCounterResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/allDevicesCounterOverTime`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDeviceCounterResponseFromJSON(jsonValue));
    }

    /**
     * Read all devices counter over time report
     */
    async readAllDevicesCounterOverTimeReport(initOverrides?: RequestInit): Promise<ReportForDeviceCounterResponse> {
        const response = await this.readAllDevicesCounterOverTimeReportRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read deployment progress report.
     */
    async readDeploymentProgressReportRaw(requestParameters: ReadDeploymentProgressReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDeploymentProgressResponse>> {
        if (requestParameters.stbGroupId === null || requestParameters.stbGroupId === undefined) {
            throw new runtime.RequiredError('stbGroupId','Required parameter requestParameters.stbGroupId was null or undefined when calling readDeploymentProgressReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.stbGroupId !== undefined) {
            queryParameters['stbGroupId'] = requestParameters.stbGroupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/deploymentProgress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDeploymentProgressResponseFromJSON(jsonValue));
    }

    /**
     * Read deployment progress report.
     */
    async readDeploymentProgressReport(requestParameters: ReadDeploymentProgressReportRequest, initOverrides?: RequestInit): Promise<ReportForDeploymentProgressResponse> {
        const response = await this.readDeploymentProgressReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device connection counters report.
     */
    async readDeviceConnectionCountersReportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDeviceConnectionCountersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/deviceConnectionCounters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDeviceConnectionCountersResponseFromJSON(jsonValue));
    }

    /**
     * Read device connection counters report.
     */
    async readDeviceConnectionCountersReport(initOverrides?: RequestInit): Promise<ReportForDeviceConnectionCountersResponse> {
        const response = await this.readDeviceConnectionCountersReportRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read device counter over time report.
     */
    async readDeviceCounterOverTimeReportRaw(requestParameters: ReadDeviceCounterOverTimeReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDeviceCounterResponse>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling readDeviceCounterOverTimeReport.');
        }

        if (requestParameters.nbTotal === null || requestParameters.nbTotal === undefined) {
            throw new runtime.RequiredError('nbTotal','Required parameter requestParameters.nbTotal was null or undefined when calling readDeviceCounterOverTimeReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.deviceTypeId !== undefined) {
            queryParameters['deviceTypeId'] = requestParameters.deviceTypeId;
        }

        if (requestParameters.nbTotal !== undefined) {
            queryParameters['nbTotal'] = requestParameters.nbTotal;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/deviceCounterOverTime`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDeviceCounterResponseFromJSON(jsonValue));
    }

    /**
     * Read device counter over time report.
     */
    async readDeviceCounterOverTimeReport(requestParameters: ReadDeviceCounterOverTimeReportRequest, initOverrides?: RequestInit): Promise<ReportForDeviceCounterResponse> {
        const response = await this.readDeviceCounterOverTimeReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device counters report.
     */
    async readDeviceCountersReportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDeviceCountersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/deviceCounters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDeviceCountersResponseFromJSON(jsonValue));
    }

    /**
     * Read device counters report.
     */
    async readDeviceCountersReport(initOverrides?: RequestInit): Promise<ReportForDeviceCountersResponse> {
        const response = await this.readDeviceCountersReportRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read device report.
     */
    async readDeviceReportRaw(requestParameters: ReadDeviceReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDeviceResponse>> {
        const queryParameters: any = {};

        if (requestParameters.macAddress !== undefined) {
            queryParameters['macAddress'] = requestParameters.macAddress;
        }

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serialNumber'] = requestParameters.serialNumber;
        }

        if (requestParameters.stbGroupsHistoryOffset !== undefined) {
            queryParameters['stbGroupsHistoryOffset'] = requestParameters.stbGroupsHistoryOffset;
        }

        if (requestParameters.stbGroupsHistoryLimit !== undefined) {
            queryParameters['stbGroupsHistoryLimit'] = requestParameters.stbGroupsHistoryLimit;
        }

        if (requestParameters.upgradeRulesHistoryOffset !== undefined) {
            queryParameters['upgradeRulesHistoryOffset'] = requestParameters.upgradeRulesHistoryOffset;
        }

        if (requestParameters.upgradeRulesHistoryLimit !== undefined) {
            queryParameters['upgradeRulesHistoryLimit'] = requestParameters.upgradeRulesHistoryLimit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/device`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDeviceResponseFromJSON(jsonValue));
    }

    /**
     * Read device report.
     */
    async readDeviceReport(requestParameters: ReadDeviceReportRequest = {}, initOverrides?: RequestInit): Promise<ReportForDeviceResponse> {
        const response = await this.readDeviceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read devices by week report.
     */
    async readDevicesByWeekReportRaw(requestParameters: ReadDevicesByWeekReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForDevicesByWeekResponse>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling readDevicesByWeekReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.deviceTypeId !== undefined) {
            queryParameters['deviceTypeId'] = requestParameters.deviceTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/devicesByWeek`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForDevicesByWeekResponseFromJSON(jsonValue));
    }

    /**
     * Read devices by week report.
     */
    async readDevicesByWeekReport(requestParameters: ReadDevicesByWeekReportRequest, initOverrides?: RequestInit): Promise<ReportForDevicesByWeekResponse> {
        const response = await this.readDevicesByWeekReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmware group by STB group ID report.
     */
    async readFirmwareGroupByStbGroupIdReportRaw(requestParameters: ReadFirmwareGroupByStbGroupIdReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForFirmwareGroupsByStbGroupResponse>> {
        if (requestParameters.stbGroupId === null || requestParameters.stbGroupId === undefined) {
            throw new runtime.RequiredError('stbGroupId','Required parameter requestParameters.stbGroupId was null or undefined when calling readFirmwareGroupByStbGroupIdReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.stbGroupId !== undefined) {
            queryParameters['stbGroupId'] = requestParameters.stbGroupId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/firmwareGroupsByStbGroup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForFirmwareGroupsByStbGroupResponseFromJSON(jsonValue));
    }

    /**
     * Read firmware group by STB group ID report.
     */
    async readFirmwareGroupByStbGroupIdReport(requestParameters: ReadFirmwareGroupByStbGroupIdReportRequest, initOverrides?: RequestInit): Promise<ReportForFirmwareGroupsByStbGroupResponse> {
        const response = await this.readFirmwareGroupByStbGroupIdReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmware group entry by STB group ID report.
     */
    async readFirmwareGroupEntryByStbGroupIdReportRaw(requestParameters: ReadFirmwareGroupEntryByStbGroupIdReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForFirmwareGroupsEntryByStbGroupResponse>> {
        if (requestParameters.stbGroupId === null || requestParameters.stbGroupId === undefined) {
            throw new runtime.RequiredError('stbGroupId','Required parameter requestParameters.stbGroupId was null or undefined when calling readFirmwareGroupEntryByStbGroupIdReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.stbGroupId !== undefined) {
            queryParameters['stbGroupId'] = requestParameters.stbGroupId;
        }

        if (requestParameters.loaderVersion !== undefined) {
            queryParameters['loaderVersion'] = requestParameters.loaderVersion;
        }

        if (requestParameters.firmwareVersion !== undefined) {
            queryParameters['firmwareVersion'] = requestParameters.firmwareVersion;
        }

        if (requestParameters.uiVersion !== undefined) {
            queryParameters['uiVersion'] = requestParameters.uiVersion;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/firmwareGroupsByStbGroupEntry`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForFirmwareGroupsEntryByStbGroupResponseFromJSON(jsonValue));
    }

    /**
     * Read firmware group entry by STB group ID report.
     */
    async readFirmwareGroupEntryByStbGroupIdReport(requestParameters: ReadFirmwareGroupEntryByStbGroupIdReportRequest, initOverrides?: RequestInit): Promise<ReportForFirmwareGroupsEntryByStbGroupResponse> {
        const response = await this.readFirmwareGroupEntryByStbGroupIdReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read firmware groups report.
     */
    async readFirmwareGroupsReportRaw(requestParameters: ReadFirmwareGroupsReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForFirmwareGroupsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.stbGroupId !== undefined) {
            queryParameters['stbGroupId'] = requestParameters.stbGroupId;
        }

        if (requestParameters.firmwareId !== undefined) {
            queryParameters['firmwareId'] = requestParameters.firmwareId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/firmwareGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForFirmwareGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Read firmware groups report.
     */
    async readFirmwareGroupsReport(requestParameters: ReadFirmwareGroupsReportRequest = {}, initOverrides?: RequestInit): Promise<ReportForFirmwareGroupsResponse> {
        const response = await this.readFirmwareGroupsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read incorrect requests report.
     */
    async readIncorrectRequestsReportRaw(requestParameters: ReadIncorrectRequestsReportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForIncorrectRequestsResponse>> {
        if (requestParameters.period === null || requestParameters.period === undefined) {
            throw new runtime.RequiredError('period','Required parameter requestParameters.period was null or undefined when calling readIncorrectRequestsReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.period !== undefined) {
            queryParameters['period'] = requestParameters.period;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/incorrectRequests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForIncorrectRequestsResponseFromJSON(jsonValue));
    }

    /**
     * Read incorrect requests report.
     */
    async readIncorrectRequestsReport(requestParameters: ReadIncorrectRequestsReportRequest, initOverrides?: RequestInit): Promise<ReportForIncorrectRequestsResponse> {
        const response = await this.readIncorrectRequestsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read incorrect requests summary report.
     */
    async readIncorrectRequestsSummaryReportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForIncorrectRequestsSummaryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/incorrectRequests/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForIncorrectRequestsSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Read incorrect requests summary report.
     */
    async readIncorrectRequestsSummaryReport(initOverrides?: RequestInit): Promise<ReportForIncorrectRequestsSummaryResponse> {
        const response = await this.readIncorrectRequestsSummaryReportRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read STB groups report.
     */
    async readStbGroupsReportRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ReportForStbGroupsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/reports/stbGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportForStbGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Read STB groups report.
     */
    async readStbGroupsReport(initOverrides?: RequestInit): Promise<ReportForStbGroupsResponse> {
        const response = await this.readStbGroupsReportRaw(initOverrides);
        return await response.value();
    }

}
